import { useCallback, useEffect } from "react"

import { useMatch } from "react-router-dom"

import {
    BASE_MAP_ID,
    useMapContext,
} from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { NavigationOrigins } from "@l2r-front/l2r-utils"

import { useNetworksDispatchContext, useNetworksStateContext } from "../../contexts/NetworksContext"

import { BaseNetworkReferentialLayer } from "../BaseNetworkReferentialLayer"

export function NetworkReferentialLayer(props) {
    const {
        mapId,
        roadToHide,
        processNavigation,
        ...layerProps
    } = props

    const matchRoad = useMatch(":slugId/:module/:subModule/:road/*")
    const matchDetail = useMatch(":slugId/:module/:subModule/:road/:detailUuid/*")

    const isSegmentView = !!matchRoad
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null
    const isDetailView = matchDetail?.params?.detailUuid

    const { setRoadSearched } = useNetworksDispatchContext()

    const { selectedLinearLocations } = useNetworksStateContext()

    const [mapState, mapDispatch] = useMapContext()
    const { currentMapStyle } = mapState
    const { setSearchRoadCallback, storeMapBoundingBox } = mapDispatch

    useEffect(() => {
        setSearchRoadCallback((searchedRoad) => {
            if (processNavigation) {
                processNavigation(null, { road: searchedRoad })
            }
        })

        return () => setSearchRoadCallback(null)
    }, [
        setSearchRoadCallback,
        processNavigation])

    const onReferentialClick = useCallback(feature => {
        if (processNavigation) {
            const linearLocation = JSON.parse(feature.properties.linearLocation)
            if (linearLocation?.[0]?.road !== road) {
                const navigationOrigin = isDetailView ? NavigationOrigins.ROAD_FROM_DETAIL
                    : isSegmentView ? NavigationOrigins.ROAD_FROM_ROAD
                        : NavigationOrigins.ROAD_FROM_NETWORK
                setRoadSearched(null)
                storeMapBoundingBox()
                processNavigation(feature, linearLocation[0], navigationOrigin)
            }
        }
    }, [isDetailView, isSegmentView, processNavigation, setRoadSearched, storeMapBoundingBox, road])

    return (
        <BaseNetworkReferentialLayer
            onClickOnFeature={onReferentialClick}
            mapId={mapId}
            mapStyle={currentMapStyle}
            roadToHide={roadToHide}
            selectedRoad={selectedLinearLocations?.[0]?.road || null}
            {...layerProps}
        />
    )
}

NetworkReferentialLayer.propTypes = {
    onClickOnFeature: PropTypes.func,
    mapId: PropTypes.string,
    roadToHide: PropTypes.string,
}

NetworkReferentialLayer.defaultProps = {
    mapId: BASE_MAP_ID,
}